import React, { useContext } from 'react';
import { Context as MainContext } from '../context/MainContext';
import '../styles/ContentStyle.css';

import { Typography } from '@material-ui/core';

//TODO Fecha ingreso locker
const InLocker = () => {
  const { state } = useContext(MainContext);
  const programedDate = (date) => {
    if (date === null || date === '') {
      return '';
    }
    const days = [
      'domingo',
      'lunes',
      'martes',
      'miércoles',
      'jueves',
      'viernes',
      'sábado',
    ];
    const months = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];
    try {
      var datTimeArray = date.split('T');
      var dateArray = datTimeArray[0].split('-');
      var timeArray = datTimeArray[1].split(':');
      var seconds = '';
      if (timeArray[2].indexOf('+') !== -1) {
        seconds = timeArray[2].substring(0, timeArray[2].indexOf('+'));
      } else{
        seconds = timeArray[2];
      }
      var reservedDate = new Date(
        dateArray[0],
        dateArray[1] - 1,
        dateArray[2],
        timeArray[0],
        timeArray[1],
        seconds
      );
      const monthIndex = reservedDate.getMonth();
      const dayIndex = reservedDate.getDay();
      return `el ${days[dayIndex]} ${dateArray[2]} de ${months[monthIndex]} del ${dateArray[0]} a las ${timeArray[0]}:${timeArray[1]}`;
    } catch (err) {
      console.log(err);
      return '';
    }
  };
  return (
    <div className="ContentContainer">
      <div className="TitleContainer">
        <Typography variant="h5">Hola {state.awb.consigneeName}</Typography>
      </div>
      <div className="MainContentContainer">
        <Typography variant="subtitle1"></Typography>
        <Typography variant="h5" className="AWBText">
          ******{state.awb.awbNumber.substring(6)}
        </Typography>
        <Typography variant="subtitle1" className="InLockerText">
          Tu envío fue ingresado a nuestros lockers{' '}
          {programedDate(state.awb.lockerPositionEntryDate)} no hagas fila y
          acercate a sucursal con tu código
        </Typography>
      </div>
      <div className="AddressContainer">
        <Typography variant="body1">
          {state.station.name}: {state.station.address1}&nbsp;&nbsp;
        </Typography>
        {state.station.google_maps_id ? (
          <a
            rel="noopener noreferrer"
            target="_blank"
            href={`https://www.google.com/maps/search/?api=1&query=DHL&query_place_id=${state.station.google_maps_id}`}
          >
            <Typography variant="body1" noWrap>
              Google Maps
            </Typography>
          </a>
        ) : null}
      </div>
      <div className="ThankYouNoteContainer">
        <Typography variant="h5" noWrap>
          ¡Gracias por elegir DHL!
        </Typography>
      </div>
    </div>
  );
};

export default InLocker;
